export const raidsPlanningScopes = ['single', 'per_encounter'] as const

type RaidsPlanningScope = typeof raidsPlanningScopes[number]
export default RaidsPlanningScope

export const raidsPlanningScopeLabels: Record<RaidsPlanningScope, string> = {
  single: 'Single setup',
  per_encounter: 'Multi (grid view)',
}
